/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import PropTypes, { string } from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import moment from 'moment';
import { PRODUCT_CATEGORY_TYPES, RC_TRANSFERRED_BY_TYPES, RC_TRANSFERRED_BY_TYPES_LIST } from 'src/containers/product-container/ProductConstants';
import { CAR_LOAN_TYPE_LIST, USED_CAR_LOAN_TYPE_LIST, SOURCE_TYPE_LIST } from 'src/containers/product-container/ProductConstants';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikInput from 'src/components/formik/FormikInput';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikToggle from 'src/components/formik/FormikToggle';
import { crossSaleSearchAction } from 'src/containers/cross-sale-container/actions/CrossSaleActions';
import ProductDropDown from 'src/business-components/ProductDropDown';
import FormikRadio from 'src/components/formik/FormikRadio';
import {
    crossSaleSearchAPI,

} from 'src/api/CrossSaleApi';
import UserDropDown from 'src/business-components/UserDropDown';

function CarLoanCaseForm({ values }) {
    // REDUX
    const dispatch = useDispatch();
    const {
        // search: {
        //     data: searchResults,
        // },
        refId
    } = useSelector((state) => state.CrossSaleReducer, shallowEqual);

    // const {
    //     search: {
    //         data: searchResults,

    //     },
    // } = useSelector((state) => state.CaseReducer, shallowEqual);

    useEffect(() => {
        //=== disbursed Amount calc
        const loanAmt = values.meta.loanAmount || 0;
        const pf = values.meta.processingFees || 0;
        const EMIAmt = values.meta.EMIAmount || 0;
        const EMIAdvance = (values.meta.EMIAdvance || 0) * EMIAmt;
        const crossAmt = values.meta.crossSaleAmount || 0;
        // const FinalAmt = (loanAmt - pf - EMIAdvance - crossAmt);
        const FinalAmt = (loanAmt - pf - EMIAdvance);
        values.meta.disbursedAmount = (FinalAmt > 0) ? FinalAmt : 0;
        //=== disbursed Amount calc

        //==Last EMI Date
        const advEMI = (values.meta.EMIAdvance > 0) ? values.meta.EMIAdvance : 0;
        // const tenure = (values.meta.tenure > 0) ? (values.meta.tenure - parseInt(advEMI)) : 0;
        const tenure = (values.meta.tenure > 0) ? (values.meta.tenure - (parseInt(advEMI) + 1)) : 0;
        const firstEMAI = moment(values.meta.firstEMI).format("DD-MMM-YYYY")
        const lastEMIDate = moment(firstEMAI).add(tenure, 'months');
        values.meta.LastEMIDate = moment(lastEMIDate).format("DD-MMM-YYYY");
        values.meta.grossLoanAmount = (parseInt(loanAmt) + parseInt(crossAmt));
        //==Last EMI Date


    }, [values.meta])


    useEffect(() => {
        const loadCrossSaleTotal = async () => {
            if (!values._id) return;

            let where = {
                refId: values._id,
                deleted: false,
                source: 'case'
            };

            const {
                data: {
                    data: crossSale,
                },
            } = await crossSaleSearchAPI({
                where,
                sortBy: 'ts',
                pageLength: 0,
                currentPage: 1,
                autopopulate: false,
            });
            var totalCrossSale = crossSale.data.reduce(function (tot, cross) {
                return tot + cross.amount;
            }, 0);
            values.meta.crossSaleAmount = totalCrossSale

        }
        loadCrossSaleTotal();
    }, [values.meta])

    return (
        <>
            <div className="mt-3">
                <h3>
                    Vehicle Information
                </h3>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label>Vehicle Name</label>
                        <ProductDropDown
                            name="meta.vehicleProductId"
                            value={values?.meta?.vehicleProductId || ''}
                            productCategory={PRODUCT_CATEGORY_TYPES.VEHICLE}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Vehicle Number</label>
                        <FormikInput
                            name="meta.vehicleNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Mfg Year</label>
                        <FormikInput
                            name="meta.vehicleModelYear"
                            type="text"
                            className="form-control"
                        />

                    </div>

                    <div className="form-group col-md-3">
                        <label>Engine Number</label>
                        <FormikInput
                            name="meta.engineNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Chasis Number</label>
                        <FormikInput
                            name="meta.chasisNumber"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Cost of Asset</label>
                        <FormikInput
                            name="meta.costOfAsset"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group col">
                            <label className="col-md-12">Sold?</label>
                            <FormikToggle name="meta.isSold" value={values?.meta?.isSold || false} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <h3>
                    Loan Information
                </h3>
                <div className="form-row">

                    <div className="form-group col-md-3">
                        <label>Loan Date</label>
                        <FormikDateTimePicker
                            name="meta.loanDate"
                            value={values?.meta?.loanDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Loan Type</label>
                        <FormikSelect
                            items={CAR_LOAN_TYPE_LIST}
                            name="meta.loanType"
                            className="form-control"
                        />
                    </div>
                    {values.meta?.loanType === "USED" &&
                        <div className="form-group col-md-3" >
                            <label>Used Car Loan</label>
                            <FormikSelect
                                items={USED_CAR_LOAN_TYPE_LIST}
                                name="meta.usedCarType"
                                className="form-control"
                            />
                        </div>
                    }
                    <div className="form-group col-md-3">
                        <label>Loan A/c No.</label>
                        <FormikInput
                            name="meta.LoanAccountNo"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Loan Amount </label>
                        <FormikInput
                            name="meta.loanAmount"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>EMI Amount</label>
                        <FormikInput
                            name="meta.EMIAmount"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>EMI Advance</label>
                        <FormikInput
                            name="meta.EMIAdvance"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Tenure (Month)</label>
                        <FormikInput
                            name="meta.tenure"
                            type="text"
                            value="0"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Business IRR(%)</label>
                        <FormikInput
                            name="meta.businessIRR"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Processing Fees </label>
                        <FormikInput
                            name="meta.processingFees"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Disbursed Amount</label>
                        <FormikInput
                            name="meta.disbursedAmount"
                            type="text"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Showroom/Dealer</label>
                        <CompanyDropDown
                            value={values.meta?.showroomDealer}
                            name="meta.showroomDealer"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>First EMI Date</label>
                        <FormikDateTimePicker
                            name="meta.firstEMI"
                            value={values?.meta?.firstEMI || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Last EMI Date</label>
                        <FormikDateTimePicker
                            name="meta.LastEMIDate"
                            value={values?.meta?.LastEMIDate || ''}
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Cross Sale Amount</label>
                        <FormikInput
                            name="meta.crossSaleAmount"
                            type="text"
                            readOnly={true}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Gross Loan Amount</label>
                        <FormikInput
                            name="meta.grossLoanAmount"
                            type="text"
                            readOnly={true}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                {values.meta?.loanType === "USED" &&
                    <div className='col-md-6'>
                        <div className="card mt-3">
                            <div className="card-body">
                            <div className="form-row">
                                <div className="form-group col-md-4">
                                    <label>RC Transferred by </label>
                                    <FormikSelect
                                        items={RC_TRANSFERRED_BY_TYPES_LIST}
                                        name="rcTransferredBy"
                                        className="form-control"
                                    />
                                </div>
                                {
                                   (values.rcTransferredBy!=="CUSTOMER")?<div className="form-group col-md-8">
                                    <label>Name </label>
                                    <UserDropDown
                                    name="rcTransferredByNameId"
                                    whereConditions={{"employmentType":values.rcTransferredBy}}
                                    value={values.rcTransferredByNameId}
                                   />
                                  </div>:null
                                }
                            </div>
                            </div>
                        </div>
                    </div>
                }
                <div className='col-md-6'>
                    <div className="card mt-3">
                        <div className="card-body">
                            <h5 className="card-title">Disbursed in favor of</h5>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <FormikRadio
                                        name="disbursedInFavor"
                                        value="customer"
                                        isChecked={(values.disbursedInFavor == "customer") ? true : false}
                                    />
                                    {' '}
                                    <label> Customer</label>
                                </div>

                                <div className="form-group col-md-6">
                                    <FormikRadio
                                        name="disbursedInFavor"
                                        value="company"
                                        isChecked={(values.disbursedInFavor == "company") ? true : false}
                                    />
                                    {' '}
                                    <label> Company (Showroom/Dealer/Autonet) </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="card mt-3">
                        <div className="card-body">
                            <h5 className="card-title">Insurance done by</h5>
                            <div className="form-row">
                                <div className="form-group col-md-4">
                                    <FormikRadio
                                        name="insuranceBy"
                                        value="autonet"
                                        isChecked={(values.insuranceBy == "autonet") ? true : false}
                                    />
                                    {' '}
                                    <label>Autonet</label>
                                </div>
                                <div className="form-group col-md-4">
                                    <FormikRadio
                                        name="insuranceBy"
                                        value="OutSource"
                                        isChecked={(values.insuranceBy == "OutSource") ? true : false}
                                    />
                                    {' '}
                                    <label>Out Source</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <h3>
                    Other Info
                </h3>
                <div className="form-row">

                    <div className="form-group col-md-3">
                        <label>Source Type</label>
                        <FormikSelect
                            items={SOURCE_TYPE_LIST}
                            name="meta.sourceType"
                            className="form-control"
                        />

                    </div>
                    <div className="form-group col-md-3">
                        <label>Source By</label>
                        <UserDropDown
                         name="meta.sourceById" 
                         />

                    </div>
                    <div className="form-group col-md-3">
                        <label>Source Payout</label>
                        <FormikInput
                            name="meta.sourcePayout"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group ml-1">
                        <label>Is Source Payout in Percentage?</label>
                        <FormikInput
                            name="meta.isSourcePayoutPercentage"
                            type="checkbox"
                            className="ml-3"
                        />
                    </div>

                </div>
                    <div className="form-row">
                        <div className="form-group col">
                            <label className="col-md-12">Invoice Recv?</label>
                            <FormikToggle
                                name="meta.invoiceRecv"
                                onlabel="Yes to go"
                                offlabel="No to go"
                            />
                        </div>

                        <div className="form-group col">
                            <label className="col-md-12">RC Recv?</label>
                            <FormikToggle name="meta.RCRecv" />
                        </div>

                        <div className="form-group col">
                            <label className="col-md-12">Insurance Received ?</label>
                            <FormikToggle name="meta.insuranceRec" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">Parivahan status ?</label>
                            <FormikToggle name="meta.parivahanStatus" />
                        </div>
                        <div className="form-group col">
                            <label className="col-md-12">RTO Slip Received ?</label>
                            <FormikToggle name="meta.rtoSlip" />
                        </div>
                    </div>
            </div>

        </>
    );
}

CarLoanCaseForm.propTypes = {
    values: PropTypes.shape({
        meta: PropTypes.shape({
            vehicleProductId: PropTypes.string,
            vehicleModelYear: PropTypes.string,
            vehicleNumber: PropTypes.string,
            engineNumber: PropTypes.string,
            chasisNumber: PropTypes.string,
            showroomDealer: PropTypes.string,
            tenure: PropTypes.number,
            loanAmount: PropTypes.number,
            disbursedAmount: PropTypes.number,
            firstEMI: PropTypes.string,
            EMIAmount: PropTypes.string,
            LastEMIDate: PropTypes.string,
        }),
    }),
};

CarLoanCaseForm.defaultProps = {
    values: {
        meta: {
            vehicleNumber: '',
        }
    },
};

export default CarLoanCaseForm;
